import { render } from "./ImageFloatButton.vue?vue&type=template&id=b41d718c&scoped=true"
import script from "./ImageFloatButton.vue?vue&type=script&lang=js"
export * from "./ImageFloatButton.vue?vue&type=script&lang=js"

import "./ImageFloatButton.vue?vue&type=style&index=0&id=b41d718c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41d718c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QImg,QBtn});
